import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import LoadingBar from "react-top-loading-bar";
import { AssetSvg } from "../../assets";
import { AppConstants, PaginationSettings } from "../../configs";
import { useAppSelector, VRIAppStateType} from "../../core";
import { AdminPageTemplate, ModalConfirmDelete, ModalAppointmentCategory, ColumnToolTip, } from "../../features";
import { AppointmentCategoryResponseModel, } from "../../models/api/modality";
import { useFunctionalityPagedAppointmentCategory, useFunctionalityAppointmentCategory, } from "../hooks";

export function PageAppointmentCategory(): JSX.Element {
  const [modalShow, setModalShow] = React.useState(false);
  const [deleteModalShow, setDeleteModalShow] = React.useState(false);
  const [loaderProgress, setLoaderProgress] = useState(0);
  const [dataToEdit, setDataToEdit] = React.useState<AppointmentCategoryResponseModel | undefined>(undefined);
  const [dataToDelete, setDataToDelete] = useState<string[]>([]);
  const [searchText, setSearchText] = useState("");
  const [pageIndex, setPageIndex] = useState(PaginationSettings.initialPageIndex);
  const [pageSize, setPageSize] = useState(PaginationSettings.initialPageSize);
  const [hasPagingData, setHasPagingData] = useState<boolean>(false);

  const handleSearch = (e: any) => {
    ReactDOM.unstable_batchedUpdates(() => {
      setSearchText(e.target.value);
      setPageIndex(1);
    });
  };
  const onChangePageIndex = (index: number) => {
    setPageIndex(index);
  };
  const onChangePageSize = (size: number) => {
    setPageSize(size);
  };

  const data = useAppSelector((state: VRIAppStateType) => ({
    userRole: state.auth.profile?.userRole,
    companyId: state.auth.profile?.companyId
  }));
  const { onDeleteAppointmentCategory } = useFunctionalityAppointmentCategory();
  const { pagedAppointmentCategoryList, pagedAppointmentCategoryListCount } =
    useFunctionalityPagedAppointmentCategory({
      CompanyId: data.userRole === AppConstants.UserRoles.ResellerAdmin ? data.companyId : "",
      pageSize: pageSize,
      pageNo: pageIndex,
      searchText: searchText?.trimStart(),
      setLoaderProgress,
    });

  useEffect(() => {
    if (pagedAppointmentCategoryList?.length > 0) {
      setHasPagingData(true);
    } else {
      setHasPagingData(false);
    }
  }, [pagedAppointmentCategoryList]);

  const onDeleteHandler = () => {
    onDeleteAppointmentCategory(dataToDelete)
      .then(() => {
        setDeleteModalShow(false);
      })
      .catch((e) => console.error(e));
  };

  const appointmentCategoryTableColumns = [
    {
      name: <ColumnToolTip data="Name" />,
      selector: (row: AppointmentCategoryResponseModel) => {
        return <ColumnToolTip data={row.name} />;
      },
    },
    // {
    //   name: "Pin",
    //   selector: (row: AppointmentCategoryResponseModel) => row.pin,
    // },

    {
      name: <ColumnToolTip data="Actions" />,
      allowOverflow: true,
      selector: (row: AppointmentCategoryResponseModel) => {
        return (
          <>
            <div
              className="btn svg-color"
              title="appointmentEdit"
              onClick={() => {
                setDataToEdit(row);
                setModalShow?.(true);
              }}
            >
              <span >
                <AssetSvg.Edit />
              </span>
            </div>

            <div
              className="btn svg-color"
              title="appointmentDelete"
              onClick={() => {
                setDeleteModalShow?.(true);
                setDataToDelete((prev) => [...prev, row.id]);
              }}
            >
              <span >
                <AssetSvg.Delete />
              </span>
            </div>
          </>
        );
      },
      omit: data.userRole === AppConstants.UserRoles.Admin ? false : true,
    },
  ];

  return (
    <>
      <LoadingBar
        progress={loaderProgress}
        onLoaderFinished={() => setLoaderProgress(0)}
      />
      <AdminPageTemplate
        pagingKey="PageAppointmentCategory"
        loaderProgress={loaderProgress}
        pageTitle="Appointment Type"
        modalControlBtnLabel="Add Appointment Type"
        tableHeaders={appointmentCategoryTableColumns}
        tableData={pagedAppointmentCategoryList || []}
        setCreateModalShow={setModalShow}
        selectableRows={true}
        searchText={searchText}
        handleSearch={handleSearch}
        pageIndex={pageIndex}
        setPageIndex={setPageIndex}
        pageSize={pageSize}
        count={pagedAppointmentCategoryListCount}
        onChangePageIndex={onChangePageIndex}
        onChangePageSize={onChangePageSize}
        hasPagingData={hasPagingData}
        setHasPagingData={setHasPagingData}
      />
      <ModalAppointmentCategory
        show={modalShow}
        handleShow={setModalShow}
        dataToEdit={dataToEdit}
        setDataToEdit={setDataToEdit}
      />
      <ModalConfirmDelete
        show={deleteModalShow}
        handleShow={setDeleteModalShow}
        deleteHandler={onDeleteHandler}
      />
    </>
  );
}
